import React from 'react'
import { Grid, Box, Link } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { modificationTypeValue } from './ModificationResponse'
import { configContext } from '../../utils/StandardReducer'
import { TubeProduct, CountryType, TubeProperties } from '../../utils/enum'
import clsx from 'clsx'
import InfoIcon from '@material-ui/icons/Info'
import styles from '@src/routes/Configurators/utils/styles'
import { checkValidKey } from '@src/routes/Configurators/utils/util'

const InitialValues = {
  FLUORESCENT: 'fluorescent',
  INTERNALMOD: 'internalMod',
  LONGOLIGO: '',
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    lead: {
      fontSize: theme.typography.pxToRem(12),
      margin: theme.spacing(3, 0),
    },
    labelSpacingnterm: {
      marginTop: theme.spacing(4),
    },
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: theme.spacing(1),
    },
    helpLink: {
      color: theme.palette.primary.main,
    },
    add: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    disableText: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.text.disabled,
      '& .MuiTypography-colorPrimary': {
        color: `${theme.palette.text.disabled}`,
      },
      '&  .MuiSvgIcon-colorSecondary': {
        color: `${theme.palette.text.disabled}`,
      },
    },
  }
})

const InternalBases = (props) => {
  const classes = useStyles()
  const GlobalCSS = styles()
  const { modificationResponseData, productType, countryCode } = props
  const { dispatch, state } = React.useContext(configContext)

  const baseValueHandlerChange = (event, base) => {
    if (
      productType === TubeProduct.Standard ||
      productType === TubeProduct.Rna ||
      productType === TubeProduct.LongOligo ||
      // The logic here is wrong. TubeProduct.Probe will always exist
      TubeProduct.Probe ||
      productType === TubeProduct.Cpeptide
    ) {
      dispatch({ type: 'FOCUS_ON_SEQUENCEBOX', data: true })
      dispatch({ type: 'UPDATE_OPTIONAL_BASES', data: base })
      dispatch({ type: 'OPTIONAL_BASES_CHANGED', data: true })
      dispatch({
        type: 'IS_CONFIRM_ORDER',
        data: false,
      })
    }
  }
  const baseValues = (categoryType: string, categoryValue: string) => {
    const baseValues: any[] = []
    modificationTypeValue(
      categoryType,
      categoryValue,
      modificationResponseData
    ).forEach((base, index) => {
      //STRAT-15511 changes start - disable the options which are not there in rulevaldation response after entering the sequence
      let valid = false
      let enable = true
      if (state.errorResponseJson?.listInternalMod) {
        state.errorResponseJson.listInternalMod.forEach((respBase) => {
          if (base.value === respBase) valid = true
        })
      } else {
        valid = true
      }
      if (!valid) enable = false
      //STRAT-15511 changes end
      baseValues.push(
        <Grid container key={index} alignItems="flex-start">
          <Grid
            item
            xs={12}
            sm={8}
            className={!enable ? classes.disableText : ''}
          >
            <div>
              {
                <FormattedMessage
                  {...checkValidKey(messages[base.label], base.label)}
                />
              }
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            className={!enable ? classes.disableText : ''}
          >
            <div>
              <Link
                component="button"
                className={classes.add}
                onClick={(e) => baseValueHandlerChange(e, base.value)}
                disabled={!enable}
              >
                <FormattedMessage {...messages.CONF_ADD_BUTTON} />
              </Link>
            </div>
          </Grid>
        </Grid>
      )
    })
    return baseValues
  }

  const internalMod = baseValues(
    InitialValues.INTERNALMOD,
    InitialValues.FLUORESCENT
  )
  const internalMods = baseValues(
    InitialValues.INTERNALMOD,
    InitialValues.LONGOLIGO
  )
  return (
    <>
      <Box
        component="p"
        className={clsx(classes.lead, GlobalCSS.globalHelpTextColor)}
      >
        {productType === TubeProduct.LongOligo ? (
          <FormattedMessage
            {...messages.CONF_OPTIONAL_BASES_HEADER_longOligo}
          />
        ) : (
          <FormattedMessage {...messages.CONF_OPTIONAL_BASES_HEADER_standard} />
        )}
      </Box>
      <Grid container>
        {internalMod.length ? (
          <Grid item xs={12} sm={4}>
            {internalMod}
          </Grid>
        ) : (
          ''
        )}
      </Grid>
      <Grid container>
        {internalMods.length ? (
          <Grid item xs={12} sm={4}>
            {internalMods}
          </Grid>
        ) : (
          ''
        )}
        {productType === TubeProduct.Cpeptide ? (
          <Grid container className={GlobalCSS.noteInfo}>
            <Grid item xs={1} className={GlobalCSS.InfoText}>
              <InfoIcon
                aria-label="info"
                className={GlobalCSS.InfoIcon}
                color="primary"
              ></InfoIcon>
            </Grid>
            <Grid item xs={11}>
              {countryCode === CountryType.cpeptideJapan ? (
                <>
                  <FormattedMessage {...messages.PC_CONTACT_CPEPTIDE_TEXT} />
                  <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage {...messages.PC_CONTACT_JP_CPEPTIDE} />
                    </span>
                  </a>
                </>
              ) : (
                <>
                  <FormattedMessage {...messages.PC_CONTACT_CPEPTIDE_IL_TEXT} />
                  <a href={`mailto:${TubeProperties.cpeptideEmail}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage {...messages.PC_CONTACT_CPEPTIDE} />
                    </span>
                  </a>
                </>
              )}
            </Grid>
          </Grid>
        ) : (
          ''
        )}
      </Grid>
      <div>
        {productType === TubeProduct.LongOligo ? (
          <Grid container className={GlobalCSS.noteInfo}>
            <Grid item xs={1} className={GlobalCSS.InfoText}>
              <InfoIcon
                aria-label="info"
                className={GlobalCSS.InfoIcon}
                color="primary"
              ></InfoIcon>
            </Grid>
            <Grid item xs={11}>
              <FormattedMessage
                {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_MSG}
              />
              {countryCode !== CountryType.cpeptideJapan ? (
                <a href={`mailto:${TubeProperties.email}`}>
                  <span className={clsx(classes.helpText, classes.helpLink)}>
                    <FormattedMessage
                      {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST}
                    />
                  </span>
                </a>
              ) : (
                <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                  <span className={clsx(classes.helpText, classes.helpLink)}>
                    <FormattedMessage {...messages.PC_CONTACT_JP_CPEPTIDE} />
                  </span>
                </a>
              )}
            </Grid>
          </Grid>
        ) : (
          ''
        )}
      </div>
    </>
  )
}

export default InternalBases
